/**
 * ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import {
    PolymerElement,
    html
} from "@polymer/polymer/polymer-element.js";
import {
    mixinBehaviors
} from "@polymer/polymer/lib/legacy/class.js";
import '../behaviors/log-out-behaviour.js';
import '../behaviors/mpin-register-behaviour.js';

class mpinCreditCardDetails extends mixinBehaviors([corpBehaviours.logOutBehaviour, corpBehaviours.mpinRegisterBehaviour], PolymerElement) {
    /** Properties definition*/
    static get properties() {
        return {
            profilePage: {
                type: Boolean,
                value: false,
                notify: true
            },
            selectedPage: {
                type: Number,
                notify: true,
                observer: 'addFocusToCreditCardHeader'
            },
            pin: {
                type: String,
                notify: true,
                value: getLabel('l_PIN')
            }
        };
    }
    /** HTML template definition*/


    static get template() {
        return html `
        <style include="corp-app-styles">
     
				</style>
        <oe-ajax id="logoutAjax" method="post" content-type="application/json" body="{{objData}}" on-response="_handleResponse" on-error="_handleError"></oe-ajax>
  
        <div class="brand-background-color mdl-grid">
        <div class="outlineOffset mdl-cell primary-light-text-l mdl-cell--12-col content-align-center" id="creditCardHeader" tabindex="0">                           
            <oe-i18n-msg class="" msgid="h_CreditCardAuthentication"></oe-i18n-msg>                      
        </div>                
        </div>                       
        <div class="main-container mdl-cell"
            wide-layout$="{{wide}}" extra-wide-layout$="{{extra-wide}}">
            <div phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" elevation="0">
            <div class="mdl-cell">
            <gold-cc-input class="light-text-color-desktop" id="creditcardNumber"  class="full-width" label="{{getLabel('l_CreditCardNumber')}}" value={{creditCardNumber}} phone$="{{phone}}" desktop$="{{desktop}}" tablet$="{{tablet}}" ></gold-cc-input>
            </div>
            <div class="mdl-grid padding-b-zero"></div>
            <div class="mdl-cell">
            <oe-date format="{{dateFormat}}" label="l_ExpiryDate" value={{creditCardExpiryDate}} 
            init="today" min="today" locale="[[locale]]"></oe-date>  
            </div>
            <div class="mdl-grid padding-b-zero"></div>
            <div class="mdl-cell">
            <paper-password-input id="loginnewPass" required="required" label="{{pin}}" value={{creditPin}}
            error-message="{{enterPwd}}" oncopy="return false" onpaste="return false" auto-validate></paper-password-input>
            </div>
            <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div><div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
                    <div class="mdl-grid"></div>
            <div class="btn align-end full-width buttonStyle">
                <div class="mdl-grid"></div>
                <div class="mdl-grid mdl-cell mdl-cell--12-col  full-width">
                    <paper-button id="creditCard_cancel_button" class="secondary-button" on-tap="cancelPage" raised>
                        <oe-i18n-msg  class="" msgid="b_Cancel"></oe-i18n-msg>
                    </paper-button>
                    <paper-button raised class="primary-button" on-tap="gotoNextPage">
                        <oe-i18n-msg id="creditAuthProceed" msgid="b_Continue"></oe-i18n-msg>
                    </paper-button>
                </div>
            </div>
        </div>
    
    <div class="mdl-grid"></div>
    <div class="mdl-grid"></div>
      `;
  }

  cancelPage() {
    if (!this.profilePage) this.goToLoginPage();
    else {
      this.backToMyProfile();
    }
  }
  gotoNextPage() {
    if (!this.creditCardNumber) {
      this.fire("oe-show-error", getLabel('m_validCreditCardNum'));
      return false;
    } else if (this.creditCardNumber && this.creditCardNumber.length != 19) {
      this.fire("oe-show-error", getLabel('m_validCreditCardNum'));
    } else if (!this.creditCardExpiryDate) {
      this.fire("oe-show-error", getLabel('m_creditCardExpiryDate'));
      return false;
    } else if (!this.creditPin) {
      this.fire("oe-show-error", getLabel('m_creditCardPin'));
      return false;
    } else {
      if (this.mpinAuthList && this.mpinAuthList.authenticationDetails && this.mpinAuthList.authenticationDetails.creditCardDetails) {
        this.authorizationDetailsBody.creditCardDetails = {
          creditCardNumber: this.creditCardNumber.replace(/\s/g, ''),
          creditPin: this.creditPin,
          creditCardExpiryDate: this.creditCardExpiryDate
        };
        this.enabledAuthList.shift();
        if (this.enabledAuthList.length > 0) this.selectedPage = this.authPage[this.enabledAuthList[0]];
        else this.postRequest();
      }
    }
  }
  addFocusToCreditCardHeader() {
    if (this.selectedPage == 2) {
      // this.$.SignOnHeader.focus();
      this.$$("#creditCardHeader").focus();
    }
  }
}

customElements.define('mpin-credit-card-details', mpinCreditCardDetails);